export async function isFileReadable(file: File | Blob): Promise<boolean> {
  try {
    if (file.size === 0) {
      return false;
    }
    const slice = file.slice(0, 1);
    await slice.arrayBuffer();
    return true;
  } catch {
    return false;
  }
}

/* TODO: apply AlbumPayload type for argument, after move payloads to packages */
export async function isFilesReadable(payload: any): Promise<boolean> {
  const promises = [];
  for (const item of payload.payloads) {
    promises.push(isFileReadable(item.payload.userFile));
  }
  const results = await Promise.all(promises);
  return results.every((res: boolean) => res === true);
}
